import { reactIcons } from "./icons";
import React from "react";

import {
  GrowthCalculater,
  Kyc,
  Withdraw,
  Report,
  PurchaseNodes,
  Login,
  RegisterPage,
  AffiliateList,
  Franchise,
  Payout,
  Fractions,
  Rewards,
  SalesReport,
  ClubReport,
  FlagReport,
  Commission,
  CouponReport,
  LeaderboardPage,
  CouponLeaderboard,
  SpinAndWin,
} from "../pages/pageListAsync";
import TelegramLogin from "../components/Forms/TelegramLogin";
// import Home from "../pages/DaoPages/Home";
import WalletLogin from "../pages/DaoPages/WalletLogin";
import moment from "moment";
import DrawReward from "../pages/DrawRewardDetails";

export const sideBarLinks = [
  {
    path: "",
    title: "Growth Calculator",
    icon: reactIcons.calculater,
    key: true,
    component: <GrowthCalculater />,
  },
  {
    path: "login",
    title: "Click here to Login",
    icon: reactIcons.login,
    key: true,
    component: <Login />,
  },
  {
    path: "register",
    title: "Register For Validator",
    icon: reactIcons.userCheck,
    key: true,
    component: <RegisterPage />,
  },
];

export const sideBar2Links = [
  {
    path: "",
    title: "Growth Calculator",
    icon: reactIcons.calculater,
    key: true,
    component: <GrowthCalculater />,
  },
  {
    path: "login",
    title: "Click here to Login",
    icon: reactIcons.login,
    key: true,
    component: <Login />,
  },
];

export const sideBar1Links = [
  {
    path: "register",
    title: "Register For Validator",
    icon: reactIcons.userCheck,
    key: true,
    component: <RegisterPage />,
  },
];
export const dashboardSideBar = [
  // {
  //   path: '/report',
  //   title: 'Report',
  //   icon: reactIcons.report,
  //   key: false,
  //   component: <Report />,
  // },
  {
    path: "portal/dashboard",
    title: "Dashboard",
    icon: reactIcons.dashboard,
    key: false,
    component: <Report />,
  },
  // {
  //   path: '/purchase-node',
  //   title: 'Purchase',
  //   icon: reactIcons.purchase,
  //   key: false,
  //   component: <Purchase />,
  // },
  {
    path: "portal/purchase-node",
    title: "Purchase",
    icon: reactIcons.purchase,
    key: false,
    component: <PurchaseNodes />,
  },

  {
    path: "portal/kyc",
    title: "KYC",
    icon: reactIcons.kyc,
    key: false,
    component: <Kyc />,
  },
  {
    path: "portal/withdraw",
    title: "Withdraw",
    icon: reactIcons.wallet,
    key: false,
    component: <Withdraw />,
  },

  {
    path: "portal/affiliate",
    title: "Validator Report",
    icon: reactIcons.affiliate,
    key: false,
    component: (
      // <PrivateRouteForAffilate>
      <AffiliateList />
      // </PrivateRouteForAffilate>
    ),
  },
  {
    path: "portal/franchise",
    title: "Rank Report",
    icon: reactIcons.franchise,
    key: "",
    component: (
      // <PrivateRouteFranchise>
      <Franchise />
      // </PrivateRouteFranchise>
    ),
  },
  {
    path: "portal/payout",
    title: "Banking & Withdrawals",
    icon: reactIcons.bank,
    key: "",
    component: (
      // <PrivateRouteFranchise>
      <Payout />
      // </PrivateRouteFranchise>
    ),
  },
  {
    path: "portal/fractions",
    title: "Fractions",
    icon: reactIcons.fraction,
    key: "",
    component: <Fractions />,
  },
  {
    path: "portal/sales-report",
    title: "Sales Report",
    icon: reactIcons.report,
    key: "",
    component: <SalesReport />,
  },
  {
    path: "portal/coupon-report",
    title: "Coupon Report",
    icon: reactIcons.coupon,
    key: "",
    component: <CouponReport />,
  },
  // {
  //   path: "portal/draw-reward",
  //   title: "Draw Reward",
  //   icon: reactIcons.trophy,
  //   key: "",
  //   component: <DrawReward />,
  // },
  // {
  //   path: "portal/leaderboard",
  //   title: "Leaderboard",
  //   icon: reactIcons.leader,
  //   key: "",
  //   component: <LeaderboardPage />,
  // },
  {
    path: "portal/coupon-leaderboard",
    title: "Coupon Leaderboard",
    icon: reactIcons.trophy || reactIcons.leader,
    key: "",
    component: <CouponLeaderboard />,
  },
  {
    path: "portal/spin-and-win",
    title: "Spin & Win",
    icon: reactIcons.gift,
    key: "",
    component: <SpinAndWin />,
  },
  // {
  //   path: "portal/rewards",
  //   title: "Rewards",
  //   icon: reactIcons.reward,
  //   key: "",
  //   component: <Rewards />
  // },
  {
    path: "portal/commission",
    title: "Commission Report",
    icon: reactIcons.report,
    key: "",
    component: <Commission />,
  },
  {
    path: "portal/dao/login",
    afterWalletConnectPath: "portal/dao",
    title: "DAO",
    icon: reactIcons.vote,
    key: "",
    component: <WalletLogin />,
  },
  // {
  //   path: "portal/flag-report",
  //   title: "Flag Report",
  //   icon: reactIcons.chat,
  //   key: "",
  //   component: <FlagReport />
  // }
];

export const dashboardSideBarForClub = [
  {
    path: "portal/club-report",
    title: "Club Report",
    icon: reactIcons.report,
    key: "",
    component: <ClubReport />,
  },
];
export const socialLinks2 = [
  {
    title: "Twitter",
    icon: reactIcons.twitter,
    url: "https://x.com/MasterStrokeTec",
  },
  {
    title: "facebook",
    icon: reactIcons.fb,
    url: "https://www.facebook.com/MasterstrokeTechnosoft",
  },
  {
    title: "Instagram",
    icon: reactIcons.instagram,
    url: "https://www.instagram.com/masterstroketechnosoft/",
  },
  // {
  //   title: 'Github',
  //   icon: reactIcons.git,
  //   url: 'https://x.com',
  // },
];
export const credentials = [
  { logo: "/images/autograph.png", title: "Signature" },
  { logo: "/images/gps.png", title: "Address" },
  { logo: "/images/stamp.png", title: "Commission and Seals" },
  { logo: "/images/approved.png", title: "Digital Certifcate" },
  {
    logo: "/images/achievements.png",
    title: "Certifications and Achievements",
  },
];

export const footerLinks = [
  { link: "/portal/tokens-scan", title: "MST Scan", icon: reactIcons.ioScan },
  // {
  //   // link: "/portal/about#about",
  //   link: "/about-mst",
  //   title: "About US",
  //   icon: reactIcons.about
  // },
  {
    link: "/terms",
    title: "Terms & Conditions",
    icon: reactIcons.policy,
  },
  {
    link: "/privacy",
    title: "Privacy Policy",
    icon: reactIcons.privacy,
  },
  // {
  //   // link: "/portal/cancellation#cancellation",
  //   link: "/cancellation",
  //   title: "Cancellation & Refund",
  //   icon: reactIcons.refund
  // },
  // { link: "/shipping#shipping", title: "Shipping & Delivery" },
  {
    // link: "/portal/contact#contact",
    link: "/contact",
    title: "Contact Us",
    icon: reactIcons.contact,
  },
];

export const formatTime = (milliseconds) => {
  const seconds = Math.floor((milliseconds / 1000) % 60);
  const minutes = Math.floor(milliseconds / 1000 / 60);
  return `${minutes < 10 ? "0" : ""}${minutes}:${
    seconds < 10 ? "0" : ""
  }${seconds}`; // Format as MM:SS
};

export const roundIfPaiseExists = (amount) => {
  return amount % 1 === 0 ? amount : Math.ceil(amount);
};

export const timeZones = [
  "(GMT-11:00) American Samoa ",
  "(GMT-11:00) International Date Line West ",
  "(GMT-11:00) Midway Island ",
  "(GMT-10:00) Hawaii ",
  "(GMT-09:00) Alaska ",
  "(GMT-08:00) Pacific Time (US &amp; Canada) ",
  "(GMT-08:00) Tijuana ",
  "(GMT-07:00) Arizona ",
  "(GMT-07:00) Chihuahua ",
  "(GMT-07:00) Mazatlan ",
  "(GMT-07:00) Mountain Time (US &amp; Canada) ",
  "(GMT-06:00) Central America ",
  "(GMT-06:00) Central Time (US &amp; Canada) ",
  "(GMT-06:00) Guadalajara ",
  "(GMT-06:00) Mexico City ",
  "(GMT-06:00) Monterrey ",
  "(GMT-06:00) Saskatchewan ",
  "(GMT-05:00) Bogota ",
  "(GMT-05:00) Eastern Time (US &amp; Canada) ",
  "(GMT-05:00) Indiana (East) ",
  "(GMT-05:00) Lima ",
  "(GMT-05:00) Quito ",
  "(GMT-04:30) Caracas ",
  "(GMT-04:00) Atlantic Time (Canada) ",
  "(GMT-04:00) Georgetown ",
  "(GMT-04:00) La Paz ",
  "(GMT-04:00) Santiago ",
  "(GMT-03:30) Newfoundland ",
  "(GMT-03:00) Brasilia ",
  "(GMT-03:00) Buenos Aires ",
  "(GMT-03:00) Greenland ",
  "(GMT-02:00) Mid-Atlantic ",
  "(GMT-01:00) Azores ",
  "(GMT-01:00) Cape Verde Is. ",
  "(GMT+00:00) Casablanca ",
  "(GMT+00:00) Dublin ",
  "(GMT+00:00) Edinburgh ",
  "(GMT+00:00) Lisbon ",
  "(GMT+00:00) London ",
  "(GMT+00:00) Monrovia ",
  "(GMT+00:00) UTC ",
  "(GMT+01:00) Amsterdam ",
  "(GMT+01:00) Belgrade ",
  "(GMT+01:00) Berlin ",
  "(GMT+01:00) Bern ",
  "(GMT+01:00) Bratislava ",
  "(GMT+01:00) Brussels ",
  "(GMT+01:00) Budapest ",
  "(GMT+01:00) Copenhagen ",
  "(GMT+01:00) Ljubljana ",
  "(GMT+01:00) Madrid ",
  "(GMT+01:00) Paris ",
  "(GMT+01:00) Prague ",
  "(GMT+01:00) Rome ",
  "(GMT+01:00) Sarajevo ",
  "(GMT+01:00) Skopje ",
  "(GMT+01:00) Stockholm ",
  "(GMT+01:00) Vienna ",
  "(GMT+01:00) Warsaw ",
  "(GMT+01:00) West Central Africa ",
  "(GMT+01:00) Zagreb ",
  "(GMT+02:00) Athens ",
  "(GMT+02:00) Bucharest ",
  "(GMT+02:00) Cairo ",
  "(GMT+02:00) Harare ",
  "(GMT+02:00) Helsinki ",
  "(GMT+02:00) Istanbul ",
  "(GMT+02:00) Jerusalem ",
  "(GMT+02:00) Kyiv ",
  "(GMT+02:00) Pretoria ",
  "(GMT+02:00) Riga ",
  "(GMT+02:00) Sofia ",
  "(GMT+02:00) Tallinn ",
  "(GMT+02:00) Vilnius ",
  "(GMT+03:00) Baghdad ",
  "(GMT+03:00) Kuwait ",
  "(GMT+03:00) Minsk ",
  "(GMT+03:00) Moscow ",
  "(GMT+03:00) Nairobi ",
  "(GMT+03:00) Riyadh ",
  "(GMT+03:00) St. Petersburg ",
  "(GMT+03:00) Volgograd ",
  "(GMT+03:30) Tehran ",
  "(GMT+04:00) Abu Dhabi ",
  "(GMT+04:00) Baku ",
  "(GMT+04:00) Muscat ",
  "(GMT+04:00) Tbilisi ",
  "(GMT+04:00) Yerevan ",
  "(GMT+04:30) Kabul ",
  "(GMT+05:00) Ekaterinburg ",
  "(GMT+05:00) Islamabad ",
  "(GMT+05:00) Karachi ",
  "(GMT+05:00) Tashkent ",
  "(GMT+05:30) Chennai ",
  "(GMT+05:30) Kolkata ",
  "(GMT+05:30) Mumbai ",
  "(GMT+05:30) New Delhi ",
  "(GMT+05:30) Sri Jayawardenepura ",
  "(GMT+05:45) Kathmandu ",
  "(GMT+06:00) Almaty ",
  "(GMT+06:00) Astana ",
  "(GMT+06:00) Dhaka ",
  "(GMT+06:00) Novosibirsk ",
  "(GMT+06:00) Urumqi ",
  "(GMT+06:30) Rangoon ",
  "(GMT+07:00) Bangkok ",
  "(GMT+07:00) Hanoi ",
  "(GMT+07:00) Jakarta ",
  "(GMT+07:00) Krasnoyarsk ",
  "(GMT+08:00) Beijing ",
  "(GMT+08:00) Chongqing ",
  "(GMT+08:00) Hong Kong ",
  "(GMT+08:00) Irkutsk ",
  "(GMT+08:00) Kuala Lumpur ",
  "(GMT+08:00) Perth ",
  "(GMT+08:00) Singapore ",
  "(GMT+08:00) Taipei ",
  "(GMT+08:00) Ulaan Bataar ",
  "(GMT+09:00) Osaka ",
  "(GMT+09:00) Sapporo ",
  "(GMT+09:00) Seoul ",
  "(GMT+09:00) Tokyo ",
  "(GMT+09:00) Yakutsk ",
  "(GMT+09:30) Adelaide ",
  "(GMT+09:30) Darwin ",
  "(GMT+10:00) Brisbane ",
  "(GMT+10:00) Canberra ",
  "(GMT+10:00) Guam ",
  "(GMT+10:00) Hobart ",
  "(GMT+10:00) Magadan ",
  "(GMT+10:00) Melbourne ",
  "(GMT+10:00) Port Moresby ",
  "(GMT+10:00) Solomon Is. ",
  "(GMT+10:00) Sydney ",
  "(GMT+10:00) Vladivostok ",
  "(GMT+11:00) New Caledonia ",
  "(GMT+12:00) Auckland ",
  "(GMT+12:00) Fiji ",
  "(GMT+12:00) Kamchatka ",
  "(GMT+12:00) Marshall Is. ",
  "(GMT+12:00) Wellington ",
  "(GMT+13:00) Nuku'alofa ",
  "(GMT+13:00) Samoa ",
  "(GMT+13:00) Tokelau Is. ",
];

export const selectOption = [
  { name: "Active", value: "accepted" },
  { name: "Inactive", value: "rejected" },
];
export const kycSelectOption = [
  { name: "Accept KYC request", value: "Accepted", disabled: false },
  { name: "Reject KYC request", value: "Rejected", disabled: false },
  { name: "Pending", value: "Pending", disabled: true },
];

export const verifyStatusList = [
  { label: "All", value: "" },
  { label: "Verified", value: "verified" },
  { label: "Not Verified", value: "notVerified" },
];
export const socialConnect = [
  // {
  //   title: "Connect Your Facebook",
  //   img: "/images/reward/facebook.png"
  // },
  {
    title: "Connect Your X",
    img: "/images/reward/x.png",
  },
  {
    title: "Connect Your Telegram",
    img: "/images/reward/telegram.png",
    component: <TelegramLogin />,
  },
];
export const activityList = [
  {
    title: "Complete Your KYC and Earn 100 MSTC Reward",
  },
  {
    title: "Click to share the new post on facebook and earn 100 MSTC Reward.",
  },
  {
    title: "Vote new poll on our telegram channel and earn 150 MSTC Reward.",
  },
];

export const socialLinks = [
  {
    title: "Twitter",
    icon: reactIcons.twitter,
    url: "https://x.com/MasterStrokeTec",
  },
  {
    title: "facebook",
    icon: reactIcons.fb,
    url: "https://www.facebook.com/MasterstrokeTechnosoft",
  },
  {
    title: "Instagram",
    icon: reactIcons.instagram,
    url: "https://www.instagram.com/masterstroketechnosoft/",
  },
  // {
  //   title: 'Github',
  //   icon: reactIcons.git,
  //   url: 'https://x.com',
  // },
  {
    title: "LinkedIn",
    icon: reactIcons.linkedIn,
    url: "https://www.linkedin.com/company/masterstroketechnosoft/",
  },
  // {
  //   title: "Youtube",
  //   icon: reactIcons.youtube,
  //   url: "https://youtube.com/@masterstroketec?si=nwJ--_MjTFFuNAex"
  // },
  {
    title: "Whatsapp",
    icon: reactIcons.whatsapp,
    url: "https://wa.me/+918983274544",
  },
];

export const navLinks = [
  // {
  //   title: 'Company',
  //   // path: '/abc',
  //   links: [
  //     { head: 'About Us', link: '/about-us' },
  //     // { head: 'Transparency', link: '/transparency' },
  //     // { head: 'Contact Us', link: '/contact' },
  //   ],
  // },
  // {
  //   title: 'Solution',
  //   // path: '/abc',
  //   links: [
  //     { head: 'Gaming', link: '/gaming' },
  //     { head: 'FortunX', link: '/fortunx' },
  //     { head: 'Sattvashuffle', link: '/sattvashuffle' },
  //     { head: 'Klethesia', link: '/klethesia' },
  //   ],
  // },
  {
    title: "Blog",
    path: "/blogs",
  },

  {
    title: "Contact Us",
    // path: 'https://portal.mstblockchain.com/',
    path: "/contact",
  },
];
export const linksRight = [
  {
    title: "Open Bets",
    path: "/dashboard/my-bets",
    icon: reactIcons.list1,
  },
  {
    title: "Deposit",
    icon: reactIcons.withdraw,
    path: "/dashboard/deposit",
  },
  {
    title: "Withdraw",
    path: "/dashboard/withdraw",
    icon: reactIcons.file,
  },
  {
    title: "Change Password",
    path: "/dashboard/settings",
    icon: reactIcons.setting,
  },
  {
    title: "Transfer Statement",
    path: "/dashboard/account-statement",
    icon: reactIcons.book,
  },
  {
    title: "Betting Profit and Loss",
    path: "/dashboard/profit-loss",
    icon: reactIcons.money,
  },
];

export const companyDetails = [
  {
    text: "Incorporation Certificate",
    url: "../images/pdf/Certificate-of-Incorporation.pdf",
  },
  { text: "PAN Card", url: "../images/pdf/Pan-Card-MST.jpg" },
  {
    text: "GST Certificate",
    url: "../images/pdf/GST-CERTIFICATE-MASTER-STROKE.pdf",
  },
  {
    text: "MSME Certificate",
    url: "../images/pdf/MSME-CERTIFICATE.pdf",
  },
  { text: "SIC Certificate", url: "../images/pdf/SIC-CERTIFICATE.pdf" },
];

export const comapnyVideos = [
  {
    title: " MST Blockchain: Important Announcement",
    url: "https://www.youtube.com/embed/JrWHiRf90Zc",
  },
  {
    title: " MST Blockchain: Add MSTC Network & Connect Wallet",
    url: "https://www.youtube.com/embed/igJcRHLTZXc?si=0HoDHfK9wOhHIaQG",
  },
  {
    title: "MST Blockchain Registration & KYC Process",
    url: "https://www.youtube.com/embed/aRnbBRBDl78?si=RxUQ9gPdrHwbBm1q",
  },
  {
    title: "2025 Business Blueprint: Strategies for Growth and Innovation ",
    url: "https://www.youtube.com/embed/1umfsXmFtBU?si=c2u5Hji4V1_O0dxZ",
  },
  {
    title: "MST BLOCKCHAIN - Process to Connect your wallet",
    url: "https://www.youtube.com/embed/G63gm5OtxoA?si=gbUKB_tNl8pqc6YW",
  },
  {
    title: "MST BLOCKCHAIN - Process to Buy MST Fraction",
    url: "https://www.youtube.com/embed/rg4vYMuipjI?si=rtAJV9IM-UalgaXs",
  },
  {
    title: "MST Blockchain - KYC Verification Process",
    url: "https://www.youtube.com/embed/xVVJ1w39zBc?si=jr85W4dVuHiGI6WW",
  },
  {
    title: "Curtain Raiser Event for MASTERSTROKE TECHNOSOFT",
    url: "https://www.youtube.com/embed/EQf2njqQoOw?si=rAwcjxcntSV_8qbk",
  },
];
export const socialGroup = [
  {
    title: "Join MST WhatsApp Group",
    icon: "/images/about/whatsapp-group.png",
    url: "https://chat.whatsapp.com/GPvsrYDhkQeB34Xz3QAm2E",
  },
  {
    title: "Follow WhatsApp Channel",
    icon: "/images/about/whatsapp-channel.png",
    url: "https://whatsapp.com/channel/0029VasOrhQ5Ui2VdNRxiL1n",
  },
  // {
  //   title: 'MST Telegram Channel',
  //    icon: '/images/about/telegram.png',
  //   url: 'https://t.me/mstblockchain',
  // },
];

export const walletDetails = [
  {
    title: "Master Address",
    address: "0xA93c8f6922159954E26C6C6011d3ED7dd166E25D",
    desc: "*Holding supply based on the halving for 18 years.",
  },
  {
    title: "Reward Wallet Address",
    address: "0xe7a4d434E68E018e3679F64DeA4F0f02E20C6809",
    desc: "*Holding Current 2 Years Rewards for distribution.",
  },
  {
    title: "Operational Admin Wallet",
    address: "0x05E50FfDeD158e571cDeDc61f80Da2a17d0f18E6",
    desc: "*Holding supply based on the halving for 18 years.",
  },
];

export const validatorList = [
  {
    title: "Validator Node 1",
    address: "0x01FF60B3FfC23e78D172418811B3108DdD6b2564",
    desc: "*Holding rewards for 1st validator node",
  },
  {
    title: "Validator Node 2",
    address: "0xd4777bdbb33f807ccbda517fc7bc07345dbef623",
    desc: "*Holding rewards for 2nd validator node",
  },
  {
    title: "Validator Node 3",
    address: "0xc0fa1cc1051ee2708908bfd4f35af3e81d612cfe",
    desc: "*Holding rewards for 3rd validator node",
  },
  {
    title: "Validator Node 4",
    address: "0xaa5f37b6035a64275f5d7615415745a62fecff18",
    desc: "*Holding rewards for 4th validator node",
  },
  {
    title: "Validator Node 5",
    address: "0xfcd7963404f2bd5662355e3f9ac4d2a12fbb8218",
    desc: "*Holding rewards for 5th validator node",
  },
];

export const ArgumentInput = ({
  label,
  type = "text",
  value,
  onChange,
  placeholder,
  error,
}) => (
  <div className="mb-4">
    {label && (
      <label className="block text-red-600 font-semibold mb-1 bg-red-100 px-2 py-1 rounded text-sm w-fit">
        {label}
      </label>
    )}
    <input
      type={type}
      value={value}
      onChange={onChange}
      className="w-full px-4 py-2 rounded-md bg-transparent border border-white text-white placeholder:text-gray-400"
      placeholder={placeholder}
    />
    {error && (
      <p className="text-red-500 text-sm mt-1">Invalid {placeholder}</p>
    )}
  </div>
);

export const DynamicArrayInput = ({
  title,
  values = [],
  onChange,
  placeholder,
  // setPublishDisable
}) => {
  const addItem = () => onChange([...values, ""]);

  const removeItem = (index) => {
    const updated = [...values];
    updated.splice(index, 1);
    onChange(updated);
  };

  const handleChange = (val, index) => {
    const updated = [...values];
    updated[index] = val;
    onChange(updated);
  };

  const validateValue = (val) => {
    if (placeholder === "address[]") {
      return val.startsWith("0x") && val.length === 42;
    }
    if (placeholder === "uint256[]" || placeholder === "uint8[]") {
      return /^\d+$/.test(val) && (val === "0" || !val.startsWith("0"));
    }
    if (placeholder === "bytes[]") {
      return /^0x[0-9a-fA-F]*$/.test(val);
    }
    if (placeholder === "bytes32[]") {
      return /^0x[0-9a-fA-F]{64}$/.test(val);
    }
    return true;
  };

  return (
    <div className="mb-6">
      {title && (
        <div className="flex gap-1 items-center">
          <label className="block text-red-600 font-semibold mb-2 bg-red-100 px-2 py-1 rounded text-sm w-fit">
            {title}
          </label>
          <span className="text-white">{placeholder}</span>
        </div>
      )}

      {values.map((val, i) => {
        const isError = !validateValue(val);
        return (
          <div key={i} className="relative mb-2">
            <div className="absolute left-0 top-1 text-red-400 text-xs w-6 text-center font-bold">
              {i + 1}
            </div>
            <input
              type="text"
              placeholder={placeholder.replace(/\[\]$/, "")}
              value={val}
              onChange={(e) => handleChange(e.target.value, i)}
              className="pl-6 w-full px-4 py-2 rounded-md bg-transparent border border-white text-white placeholder:text-gray-400"
            />
            {isError && (
              <p className="text-red-500 text-xs mt-1 pl-6">
                Invalid {placeholder.replace(/\[\]$/, "")}
              </p>
            )}
            <button
              type="button"
              onClick={() => removeItem(i)}
              className="absolute right-0 top-1 bg-red-600 text-white text-xs rounded px-2 py-1 hover:bg-red-700"
            >
              Remove
            </button>
          </div>
        );
      })}

      <button
        type="button"
        onClick={addItem}
        className="mt-2 text-sm px-3 py-1 border border-red-500 text-white rounded hover:bg-red-600"
      >
        + Add Address
      </button>
    </div>
  );
};

export const validateInputByType = (type, value) => {
  if (type === "address") {
    return (
      typeof value === "string" && value.length === 42 && value.startsWith("0x")
    );
  }
  if (type === "bytes") {
    return typeof value === "string" && /^0x[0-9a-fA-F]*$/.test(value);
  }
  if (type === "bytes32") {
    return (
      typeof value === "string" &&
      value.length === 66 &&
      /^0x[0-9a-fA-F]{64}$/.test(value)
    );
  }
  if (type === "uint256" || type === "uint8") {
    return typeof value === "string" && /^[1-9]\d*$|^0$/.test(value);
  }
  if (type === "string") {
    return typeof value === "string";
  }
  if (type === "address[]") {
    return (
      Array.isArray(value) &&
      value.every(
        (v) => typeof v === "string" && v.length === 42 && v.startsWith("0x"),
      )
    );
  }
  return false;
};

export function formatCompactNumber(value) {
  const num = Number(value);
  if (isNaN(num)) return "0";
  if (num >= 1_000_000_000) {
    return (num / 1_000_000_000).toFixed(2) + "B";
  } else if (num >= 1_000_000) {
    return (num / 1_000_000).toFixed(2) + "M";
  } else if (num >= 1_000) {
    return (num / 1_000).toFixed(2) + "K";
  } else {
    return num;
  }
}

export const parseVotingPower = (value) => {
  if (typeof value === "number") return value;
  if (typeof value === "string") {
    const trimmed = value.trim().toUpperCase();
    const num = parseFloat(trimmed);
    if (isNaN(num)) return 0;
    if (trimmed.endsWith("B")) return num * 1_000_000_000;
    if (trimmed.endsWith("M")) return num * 1_000_000;
    if (trimmed.endsWith("K")) return num * 1_000;
    return num;
  }

  return 0;
};

export function isProposalTimeChecker(givenTime) {
  return moment(givenTime).isBefore(moment());
}

export const VoteBar = ({
  percent,
  color,
  textColor = "white",
  remainingColor = "#4d0000",
}) => {
  const percentValue = parseInt(percent);

  return (
    <div className="relative w-full h-10 rounded overflow-hidden">
      <div
        className="absolute inset-0"
        style={{ backgroundColor: remainingColor }}
      ></div>

      {/* Filled bar with arrow end */}
      <div
        className="h-full flex items-center justify-end pr-4 text-sm font-semibold relative z-10"
        style={{
          width: `${percentValue}%`,
          backgroundColor: color,
          color: textColor,
          clipPath:
            "polygon(0 0, calc(100% - 20px) 0, 100% 50%, calc(100% - 20px) 100%, 0 100%)",
        }}
      >
        {percent}
      </div>
    </div>
  );
};

export const getReadableTime = (seconds) => {
  if (seconds < 60) {
    return `${seconds} sec`;
  }
  const minutes = Math.floor(seconds / 60);
  if (minutes < 60) {
    return `${minutes} min`;
  }
  const hours = Math.floor(minutes / 60);
  if (hours < 24) {
    return `${hours} hr`;
  }
  const days = Math.floor(hours / 24);
  return `${days} day${days > 1 ? "s" : ""}`;
};

export function LiveSvg() {
  const strokes = [18, 14, 10, 6, 2, 0.5];
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 100 100"
      className="w-[30px] h-[30px] md:w-[30px] md:h-[30px]"
    >
      {strokes.map((r, index) => (
        <circle key={index} cx="50" cy="50" r={r} fill="none" stroke="#04a928">
          <animate
            attributeName="r"
            from={r}
            to="0"
            dur="1.1s"
            repeatCount="indefinite"
            keyTimes="0;1"
            begin={`${index * 0.275}s`}
          />
        </circle>
      ))}
    </svg>
  );
}

export const getFormattedAadhar = (value) => {
  const digits = value;
  if (!digits) return "";
  return (
    digits
      .match(/.{1,4}/g) // split into chunks of 4
      ?.join("-") ?? ""
  );
};

export const metaList = [
  {
    path: "/",
    title: "MST Blockchain | Next-Gen Layer 1 Blockchain Platform",
    description:
      "MST Blockchain is a sustainable Layer 1 platform offering low-cost solutions, Web3 infrastructure, and decentralized tools for enterprises, retail, and gaming.",
    keywords:
      "Layer 1 blockchain platform | Sustainable blockchain platform | Low-cost blockchain solutions | Decentralized information sharing | Enterprise blockchain adoption | Web3 infrastructure for developers | Blockchain for retail and gaming | Community governed blockchain",
    url: "https://mstblockchain.com/",
    ogTags: true,
  },
  {
    path: "/portal",
    title: "Fractional Node Ownership for Validators | MST Blockchain",
    description:
      "MST Blockchain enables fractional node ownership for validators, making it easy to earn rewards and join network security with low entry barriers.",
    keywords: "Node fractional ownership blockchain",
    url: "https://mstblockchain.com/portal/",
    ogTags: false,
  },
  {
    path: "/about-mst",
    title: "About us | MST Blockchain",
    description:
      "Learn more about MST Blockchain, a leading innovator in blockchain technology, delivering secure, scalable, and decentralized solutions for businesses and developers worldwide.",
    keywords: "",
    url: "https://mstblockchain.com/about-mst",
    ogTags: false,
  },
  {
    path: "/blogs",
    title: "Blog – Insights, Trends & Updates | MST Blockchain",
    description:
      "The MST Blockchain Blog covers blockchain news, industry insights, project updates, and technology trends in Web3, DeFi, NFTs, and decentralized systems.",
    keywords: "",
    url: "https://mstblockchain.com/blog",
    ogTags: false,
  },
  {
    path: "/contact",
    title: "Contact Us | MST Blockchain",
    description:
      "Get in touch with MST Blockchain for partnership inquiries, technical support, or general questions. Our team is ready to assist you with blockchain solutions.",
    keywords: "",
    url: "https://mstblockchain.com/contact",
    ogTags: false,
  },
  {
    path: "/validator-benefits",
    title: "Validator Benefits | MST Blockchain",
    description:
      "Become a validator on MST Blockchain and gain crypto rewards, free gas fees, early access to developer tools, expert support, and long-term ecosystem advantages.",
    keywords: "",
    url: "https://mstblockchain.com/validator-benefits",
    ogTags: false,
  },
  {
    path: "/transparency",
    title: "Transparency & Data Ownership | MST Blockchain",
    description:
      "MST Blockchain delivers full transparency and secure data ownership, enabling verifiable, tamper-resistant transactions and asset protection across the ecosystem.",
    keywords: "",
    url: "https://mstblockchain.com/transparency",
    ogTags: false,
  },
  {
    path: "/aml-policies",
    title: "Anti-Money Laundering Policy | MST Blockchain",
    description:
      "MST Blockchain enforces strict AML policies using advanced analytics to detect, prevent, and report suspicious transactions on the network.",
    keywords: "",
    url: "https://mstblockchain.com/aml-policies",
    ogTags: false,
  },
  {
    path: "/cancellation",
    title: "Cancellation & Refund Policy | MST Blockchain",
    description:
      "All sales on MST Blockchain are final. No refunds, returns, or cancellations are allowed for tokens, NFTs, or digital asset transactions.",
    keywords: "",
    url: "https://mstblockchain.com/cancellation",
    ogTags: false,
  },
  {
    path: "/kyc-policies",
    title: "KYC Policies & Identity Verification | MST Blockchain",
    description:
      "MST Blockchain enforces rigorous KYC policies aligned with global regulations, ensuring identity verification and secure, trusted participation in our ecosystem.",
    keywords: "",
    url: "https://mstblockchain.com/kyc-policies",
    ogTags: false,
  },
  {
    path: "/team-and-partners",
    title: "Team & Partners | MST Blockchain",
    description:
      "Meet MST Blockchain’s team of industry veterans and technology experts—and discover our partners advancing innovation, security, and decentralization.",
    keywords: "",
    url: "https://mstblockchain.com/team-and-partners",
    ogTags: false,
  },
  {
    path: "/privacy",
    title: "Privacy Policy | MST Blockchain",
    description:
      "Read MST Blockchain’s Privacy Policy to understand how we collect, use, and protect your personal data in compliance with global data protection standards.",
    keywords: "",
    url: "https://mstblockchain.com/privacy",
    ogTags: false,
  },
  {
    path: "/terms",
    title: "Terms and Conditions | MST Blockchain",
    description:
      "Review MST Blockchain’s Terms and Conditions outlining your rights, responsibilities, and usage rules when accessing our platform and digital services.",
    keywords: "",
    url: "https://mstblockchain.com/terms",
    ogTags: false,
  },

];

export function timeAgo(timestamp) {
  const now = new Date();
  const time = new Date(timestamp);
  const diffMs = now - time; // milliseconds ka difference
  const diffSec = Math.floor(diffMs / 1000);

  if (diffSec <= 2) {
    return "Just now";
  } else if (diffSec < 60) {
    return `${diffSec} sec ago`;
  } else if (diffSec < 3600) {
    const minutes = Math.floor(diffSec / 60);
    return `${minutes} min${minutes > 1 ? "s" : ""} ago`;
  } else if (diffSec < 86400) {
    const hours = Math.floor(diffSec / 3600);
    return `${hours} hour${hours > 1 ? "s" : ""} ago`;
  } else {
    const days = Math.floor(diffSec / 86400);
    return `${days} day${days > 1 ? "s" : ""} ago`;
  }
}
export const drawDetails = {
  drawName: "Lucky Draw #12",
  contractAddress: "0x123456789ABCDEF123456789ABCDEF123456789",
  contractLink:
    "https://polygonscan.com/address/0x123456789ABCDEF123456789ABCDEF123456789",

  total: 48,
  selected: 3,
  rejected: 45,
};
export const selectedCoupons = [
  {
    id: 1,
    name: "John Doe",
    coupon: "CPN123456",
  },
  {
    id: 2,
    name: "Alex Smith",
    coupon: "CPN123457",
  },
  {
    id: 3,
    name: "Mike Johnson",
    coupon: "CPN123458",
  },
];

export const rejectedCoupons = [
  {
    id: 1,
    name: "Chris",
    coupon: "CPN999111",
  },
  {
    id: 2,
    name: "David",
    coupon: "CPN999222",
  },
];
export const prizeData = [
  {
    rank: "1st",
    amount: "₹6,26,200",
    coupon: "CPN123456",
  },
  {
    rank: "2nd",
    amount: "₹4,69,650",
    coupon: "CPN123457",
  },
  {
    rank: "3rd",
    amount: "₹3,13,100",
    coupon: "CPN123458",
  },
  {
    rank: "4th",
    amount: "₹1,56,550",
    coupon: "CPN123459",
  },
  {
    rank: "5th",
    amount: "₹93,930",
    coupon: "CPN123460",
  },
  {
    rank: "6th",
    amount: "₹62,620",
    coupon: "CPN123461",
  },
  {
    rank: "7th",
    amount: "₹31,310",
    coupon: "CPN123462",
  },

  {
    rank: "8th - 27th",
    amount: "₹15,655",
    winners: 20,
    coupons: ["CONS100", "CONS101", "CONS102", "CONS103", "CONS104"],
  },

  {
    rank: "28th - 67th",
    amount: "₹7,827.50",
    winners: 40,
    coupons: ["CONS200", "CONS201", "CONS202", "CONS203", "CONS204"],
  },

  {
    rank: "68th - 90th",
    amount: "3 Fraction",
    winners: 23,
    coupons: ["CONS300", "CONS301", "CONS302"],
  },

  {
    rank: "91st - 150th",
    amount: "2 Fraction",
    winners: 60,
    coupons: ["CONS400", "CONS401", "CONS402"],
  },

  {
    rank: "151st - 250th",
    amount: "1 Fraction",
    winners: 100,
    coupons: ["CONS500", "CONS501", "CONS502"],
  },
];

export const prizeGroups = [
  {
    rank: "8th - 27th",
    amount: "₹15,655",
    winners: Array.from({ length: 20 }, (_, i) => ({
      rank: i + 8,
      coupon: `CPN${100 + i}`,
      amount: "₹15,655",
    })),
  },

  {
    rank: "28th - 67th",
    amount: "₹7,827.50",
    winners: Array.from({ length: 40 }, (_, i) => ({
      rank: i + 28,
      coupon: `CPN${200 + i}`,
      amount: "₹7,827.50",
    })),
  },

  {
    rank: "68th - 90th",
    amount: "3 Fraction",
    winners: Array.from({ length: 23 }, (_, i) => ({
      rank: i + 68,
      coupon: `CPN${300 + i}`,
      amount: "3 Fraction",
    })),
  },

  {
    rank: "91st - 150th",
    amount: "2 Fraction",
    winners: Array.from({ length: 60 }, (_, i) => ({
      rank: i + 91,
      coupon: `CPN${400 + i}`,
      amount: "2 Fraction",
    })),
  },

  {
    rank: "151st - 250th",
    amount: "1 Fraction",
    winners: Array.from({ length: 100 }, (_, i) => ({
      rank: i + 151,
      coupon: `CPN${500 + i}`,
      amount: "1 Fraction",
    })),
  },
];
